import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import axios from 'axios';
// Global Components
import hljsVuePlugin from '@highlightjs/vue-plugin';

import Multiselect from 'vue-multiselect';
//import { definePreset } from 'primevue/preset'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import DataTable from 'primevue/datatable'
import Column from 'primevue/column';
import { plugin, defaultConfig } from '@formkit/vue';
import WootSwitch from 'components/ui/Switch.vue';
import WootWizard from 'components/ui/Wizard.vue';
import FloatingVue, { options } from 'floating-vue';
import WootUiKit from 'dashboard/components';
import App from 'dashboard/App.vue';
import i18nMessages from 'dashboard/i18n';
import createAxios from 'dashboard/helper/APIHelper';

import commonHelpers, { isJSONValid } from 'dashboard/helper/commons';
import { sync } from 'vuex-router-sync';
import { createPinia } from 'pinia';
import router, { initalizeRouter } from 'dashboard/routes';
import store from 'dashboard/store';
import constants from 'dashboard/constants/globals';
import * as Sentry from '@sentry/vue';
import {
  initializeAnalyticsEvents,
  initializeChatwootEvents,
} from 'dashboard/helper/scriptHelpers.js';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon.vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { domPurifyConfig } from 'shared/helpers/HTMLSanitizer.js';

import { vResizeObserver } from '@vueuse/components';
import { directive as onClickaway } from 'vue3-click-away';

import 'floating-vue/dist/style.css';
import { Avatar, Button, Checkbox, FileUpload, InputGroup, InputGroupAddon, InputText, Textarea, Toast, Dropdown, Tag, IconField, Select, OverlayPanel } from 'primevue';
import 'primeicons/primeicons.css'
import ToastService from 'primevue/toastservice';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import RadioButton from 'primevue/radiobutton';
import RadioButtonGroup from 'primevue/radiobuttongroup';
import Divider from 'primevue/divider';

import '../styles/primevue-overrides.css';

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  messages: i18nMessages,
});

sync(store, router);

const app = createApp(App);
/*const preset = definePreset({
  name: 'Aura',
  theme: Aura,
  cssVars: {
    // Add your custom CSS variables here
    '--primary-color': '#007bff',
    '--secondary-color': '#6c757d',
    '--success-color': '#28a745',
    '--danger-color': '#dc3545',
    '--warning-color': '#ffc107',
    '--info-color': '#17a2b8',
    '--light-color': '#f8f9fa',
    '--dark-color': '#343a40',
  },
  options: {
    darkModeSelector: '.my-app-dark',
  }
});*/
app.config.devtools = true;
app.config.warnHandler = (msg, instance, trace) => {
  console.log("[Vue Warning]:", msg, trace);
};
app.config.errorHandler = (err, instance, info) => {
  console.log("[Vue Error]:", err, info);
};
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark',
    },
    cssVars: {
      '--primary-color': 'var(--primary-color)',
      '--primary-color-text': 'var(--primary-color-text)',
      '--secondary-color': 'var(--secondary-color)',
      '--secondary-color-text': 'var(--secondary-color-text)',
      '--success-color': 'var(--success-color)',
      '--success-color-text': 'var(--success-color-text)',
      '--danger-color': 'var(--danger-color)',
      '--danger-color-text': 'var(--danger-color-text)',
      '--warning-color': 'var(--warning-color)',
      '--warning-color-text': 'var(--warning-color-text)',
      '--info-color': 'var(--info-color)',
      '--info-color-text': 'var(--info-color-text)',
      '--background-color': 'var(--background-color)',
      '--surface-color': 'var(--surface-color)',
      '--card-color': 'var(--card-color)',
      '--overlay-color': 'var(--overlay-color)',
      '--text-color': 'var(--text-color)',
      '--text-secondary-color': 'var(--text-secondary-color)',
      '--border-color': 'var(--border-color)',
      '--shadow-color': 'var(--shadow-color)',
      '--hover-color': 'var(--hover-color)',
      '--focus-color': 'var(--focus-color)',
    },
  }
})
.component('RadioButton', RadioButton)
.component('Divider', Divider)
.component('RadioButtonGroup', RadioButtonGroup)
.component('Tabs', Tabs)
.component('TabList', TabList)
.component('Tab', Tab)
.component('TabPanels', TabPanels)
.component('TabPanel', TabPanel)
.component('DataTable', DataTable)
.component('Column', Column)
.component('Button', Button)
.component('InputGroup', InputGroup)
.component('InputGroupAddon', InputGroupAddon)
.component('InputText', InputText)
.component('InputGroup', InputGroup)
.component('InputGroupAddon', InputGroupAddon)
.component('Dropdown', Dropdown)
.component('Textrea', Textarea)
.component('Checkbox', Checkbox)
.component('FileUpload', FileUpload)
.component('Avatar', Avatar)
.component('Toast', Toast)
.component('Tag', Tag)
.component('IconField',IconField)
.component('OverlayPanel', OverlayPanel)
.component('Select', Select)
app.use(ToastService);
app.use(i18n);
app.use(store);
app.use(createPinia());
app.use(router);

// [VITE] Disabled this, need to renable later
if (window.errorLoggingConfig) {
  Sentry.init({
    app,
    dsn: window.errorLoggingConfig,
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
      /chrome-extension:/i,
      /extensions\//i,

      // Locally saved copies
      /file:\/\//i,

      // Safari extensions.
      /safari-web-extension:/i,
      /safari-extension:/i,
    ],
    integrations: [Sentry.browserTracingIntegration({ router })],
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });
}

app.use(VueDOMPurifyHTML, domPurifyConfig);
app.use(WootUiKit);
app.use(
  plugin,
  defaultConfig({
    rules: {
      JSON: ({ value }) => isJSONValid(value),
    },
  })
);
app.use(FloatingVue, {
  instantMove: true,
  arrowOverflow: false,
  disposeTimeout: 5000000,
});
app.use(hljsVuePlugin);

app.component('multiselect', Multiselect);
app.component('woot-switch', WootSwitch);
app.component('woot-wizard', WootWizard);
app.component('fluent-icon', FluentIcon);

app.directive('resize', vResizeObserver);
app.directive('on-clickaway', onClickaway);

// load common helpers into js
commonHelpers();
window.WootConstants = constants;
window.axios = createAxios(axios);
// [VITE] Disabled this we don't need it, we can use `useEmitter` directly
// app.prototype.$emitter = emitter;

initializeChatwootEvents();
initializeAnalyticsEvents();
initalizeRouter();

window.onload = () => {
  app.mount('#app');
};
